
// let LM = {};
const LM = [];
export const loadingMixin = {
  data() {
    return {
      MLoading: false,
    }
  },
  methods: {
    MSwitchLoading(value) {
      this.MLoading = value ?? !this.MLoading;
    },
    loading(key = 'def') {
      // LM[key] = true;
      LM.push(true);
      const { isActive } = this.$q.loading;
      if (!isActive) {
        // const find = Object.values(LM).some(it => it === true)
        const find = LM.some(it => it === true)
        if (find) {
          this.$q.loading.show();
        }
      }
    },
    hide(key = 'def') {
      // LM[key] = false;
      LM.pop();
      const { isActive } = this.$q.loading;
      if (isActive) {
        // const find = Object.values(LM).some(it => it === true)
        const find = LM.length;
        if (!find) {
          this.$q.loading.hide();
          // LM = {};
          LM.length = 0;
        }
      }
    }
  }
};
